
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import { SweetAlertResult } from 'sweetalert2';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import { confirmSwal } from '@/helper/swals';
    import Text from '@/types/Text';
    import { VForm } from '@/types/Components';
    import { DeleteTextPayload, TexteFilter, UpdateTextPayload } from '@/store/texte';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('texte', ['loaders']),
            ...mapState('authentication', ['impfstelle_id']),
        },
        methods: {
            ...mapActions('texte', ['updateText', 'deleteText']),
        },
    })
    export default class TexteDetail extends Vue {
        @Prop() visible!: boolean;
        @Prop() text!: Text;
        @Prop() filter!: TexteFilter;

        public $refs!: {
            form: VForm;
        };

        public updateText!: (payload: UpdateTextPayload) => void;
        public deleteText!: (payload: DeleteTextPayload) => void;

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }
            }
        }

        public onClickSave(): void {
            if (this.$refs.form.validate()) {
                this.updateText({ text: this.text, filter: this.filter });
            }
        }

        public onClickDelete(): void {
            confirmSwal('Löschen', 'Text endgültig löschen?', 'Löschen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deleteText({ text: this.text, filter: this.filter });
                    }
                });
        }
    }
